import { Modal } from "antd";
import Loading from "../../../../components/Loading";
import TicketsList from "../../../../components/TicketsList";
import { IAppUser } from "../../../../interfaces";
import useGiveawayTickets from "./useGiveawayTickets";

interface IProps {
    open: boolean;
    onClose: () => void;
    giveawayId: number;
    appUser: IAppUser;
}

export default function ModalGiveawayTickets({ open, onClose, giveawayId, appUser }: IProps) {

    const {
        isLoading,
        tickets
    } = useGiveawayTickets({giveawayId, id: appUser.id!});

    return (
        <Modal width={1000} open={open} title={'Bilhetes do usuário'} cancelButtonProps={{
            hidden: true
        }} onCancel={onClose} onOk={onClose}>
            <Loading loading={isLoading} >
                <TicketsList
                    paginated={true}
                    title={appUser?.name}
                    tickets={tickets}
                    isLoading={isLoading}
                    giveawayId={giveawayId}
                    emptyListMessage="Usuário não possui bilhetes neste sorteio"
                />
            </Loading>
        </Modal>
    )
}
